import { appraisalService } from 'Services/appraisalService'
import { useState, useEffect } from 'react'

interface AppraisalSettings {
  id: number
  appraisalYear: number
  appraisalQuarter: number
  appraisalOpen: boolean
  payslipMonth: string
  appraisalClosingDate: string
  payslipYear: any
  createdAt: string
}

const useAppraisalSettings = () => {
  const [settings, setSettings] = useState<AppraisalSettings | null>(null)

  const getAppraisalSettings = async () => {
    try {
      const res = await appraisalService.settings()
      console.log('settings', res.data.data)
      setSettings(res.data.data)
    } catch (error) {
      console.error('Error fetching appraisal settings:', error)
    }
  }

  useEffect(() => {
    getAppraisalSettings()
  }, [])

  return { settings, setSettings }
}

export default useAppraisalSettings
